import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { Richtext } from 'Packages/FacetDesign/Components/Richtext';
import { FDBodyText } from '@facet-wealth/design';

const RoadmapDeliverableInvestingDetailsMetaOverride = buildFacetDesignOverride()
  .nameOverride('disclaimer', {
    _component: () => Richtext,
    _customProps: {
      Component: FDBodyText, size: 'sm', align: 'center', color: 'textDisabled',
    },
  }, overrideReadOnly);

export default RoadmapDeliverableInvestingDetailsMetaOverride;
